import { render } from "./ElementAccordion.vue?vue&type=template&id=993d31ee"
import script from "./ElementAccordion.vue?vue&type=script&lang=js"
export * from "./ElementAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__